import { baseUrl } from "@/config/env";
import request from "@/router/axios";
import { parseParam } from "@/util/util";
// downloadPureWaterQrZip
export const downloadPureWaterQrZip = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/shop/downloadPureWaterQrZip`,
    method: "POST",
    ContentType: "multipart/form-data",
    responseType: "blob",
    data: params,
  });
}
// 获取代理商Id
export const getRootDepartmentId = () => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/department/getRootDepartmentId`,
    method: "GET",
  });
};
// getDownloadCode
export const getDownloadCode = (params) => {
  return request({
    url: `${baseUrl}/joins-product/v1/app_product/downloadMiniProgramCodeImageV2`,
    method: "POST",
    responseType: 'blob',
    data: params,
  });
};
export const findShop = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/shop?` + params,
    method: "GET",
  });
};
export const v1BindingList = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/binding/list?` + params,
    method: "GET",
  });
};

export const prohibit = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/shop/${params}`,
    method: "DELETE",
  });
};

export const findShopAll = () => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/shop/choose`,
    method: "GET",
  });
};
export const v1BindingDetermine = (params) => {
  //检查商户是否注册
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/binding/determine?` + params,
    method: "GET",
  });
};

export const approve = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/shop/approve`,
    method: "PUT",
    data: data,
  });
};

export const findShopDetail = (id) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/shop/detail/${id}`,
    method: "GET",
  });
};

export const findClassify = () => {
  return request({
    url: `${baseUrl}/joins-sales/v1/classify/secondList`,
    method: "GET",
  });
};

export const addShop = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/shop`,
    method: "POST",
    data: data,
  });
};
export const v1BindingBindingShop = (data) => {
  //绑定商户
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/binding/bindingShop`,
    method: "POST",
    data: data,
  });
};

export const v1BindingUpdateOrderEnabled = (params) => {
  //修改商户报单开关
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/binding/updateOrderEnabled?` + params,
    method: "PUT",
  });
};

export const v1AppShopCheckOrderEnabled = (params) => {
  //扫码前校验报单权限
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/app_shop/checkOrderEnabled?` + params,
    method: "GET",
  });
};
export const v1BindingRegistryShop = (data) => {
  //注册商户
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/binding/registryShop`,
    method: "POST",
    data: data,
  });
};

export const editShop = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/shop/edit`,
    method: "PUT",
    data: data,
  });
};

export const delShop = (deleteOption, ids) => {
  let temp = ids.join(",");
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/shop/${temp}?option=${deleteOption}`,
    method: "DELETE",
  });
};
